const state = {
  tableHeight: 500
}

const mutations = {
  SET_TABLE_HEIGHT: (state, tableHeight) => {
    state.tableHeight = tableHeight
  }
}
export default {
  namespaced: true,
  state,
  mutations
}
